import { MapType } from "types/map.type";
import { DropdownSelect } from "@/components/form-control";

export type SelectMapTypeTypeProps = {
  mapType: MapType;
  onSelectMapType: (value: MapType) => void;
};

const mapTypeValues: MapType[] = [MapType.MAPBOX, MapType.ESRI_MAP, MapType.GOOGLE_MAP, MapType.YANDEX_MAP];

export const SelectMapType = ({ mapType = MapType.MAPBOX, onSelectMapType }: SelectMapTypeTypeProps) => {
  return (
    <DropdownSelect
      value={mapType}
      options={mapTypeValues}
      onValueChange={(value) => onSelectMapType(value as MapType)}
      className="shadow-lg"
    />
  );
};
